import { ClienteAnaliseMercadoProjecaoUpdateStatus } from '../cliente-analise-mercado-projecao-update-status';
import { ClienteAnaliseMercadoFunilVendaSearch } from '../../funil-venda/cliente-analise-mercado-funil-venda-search';
import { statusProjetadoPerdido } from '../../status-projetado';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

export class ClienteAnaliseMercadoProjecaoPerda {
    // Cliente
    tipoPessoa: number;
    codigoIntegracaoErpCliente: string;
    nomeCliente: string;
    nomeFantasiaCliente: string;
    // Representante
    codigoIntegracaoErpRepresentante: string;
    nomeRepresentante: string;
    nomeFantasiaRepresentante: string;

    /** Atualização da perda das projeções do cliente */
    entityUpdatePerda: ClienteAnaliseMercadoProjecaoUpdateStatus;

    /** Evento de drop na perda das projeções do cliente através do funil de vendas **/
    dropEventFunilVenda: CdkDragDrop<ClienteAnaliseMercadoFunilVendaSearch[]>;

    constructor(idCliente: number, mes: number, ano: number, statusProjetadoAtual: number, idEtapaNegociacaoProjecaoAtual: number) {
        this.entityUpdatePerda = new ClienteAnaliseMercadoProjecaoUpdateStatus(idCliente, mes, ano, statusProjetadoAtual, idEtapaNegociacaoProjecaoAtual, statusProjetadoPerdido.id);
    }

    /** Seta os dados das perdas das projeções do cliente através do funil de vendas */
    setFunilVenda(entityFunilvenda: ClienteAnaliseMercadoFunilVendaSearch, dropEvent: CdkDragDrop<ClienteAnaliseMercadoFunilVendaSearch[]> = null) {
        if (entityFunilvenda) {
            // Cliente
            this.tipoPessoa = entityFunilvenda.tipoPessoa;
            this.codigoIntegracaoErpCliente = entityFunilvenda.codigoIntegracaoErpCliente;
            this.nomeCliente = entityFunilvenda.nomeCliente;
            this.nomeFantasiaCliente = entityFunilvenda.nomeFantasiaCliente;
            // Representante
            this.codigoIntegracaoErpRepresentante = entityFunilvenda.codigoIntegracaoErpRepresentante;
            this.nomeRepresentante = entityFunilvenda.nomeRepresentante;
            this.nomeFantasiaRepresentante = entityFunilvenda.nomeFantasiaRepresentante;
            // Perda
            this.entityUpdatePerda.idMotivoPerdaProjetado = entityFunilvenda.idMotivoPerdaProjetado;
            this.entityUpdatePerda.justificativaPerdaProjetado = entityFunilvenda.justificativaPerdaProjetado;
        }

        this.dropEventFunilVenda = dropEvent;
    }
}
